import React, { memo } from 'react';
import WebsiteFilters from 'components/filters/WebsiteFilters';

export const StaticPagesFilters = memo(
  ({
    onFiltersChange,
    shoppingCenters = [],
    companies = [],
    categories = [],
    loadingShoppingCenters = false,
    filters = {},
  }) => {
    return (
      <WebsiteFilters
        shoppingCenters={shoppingCenters}
        companies={companies}
        categories={categories}
        onFiltersChange={onFiltersChange}
        loading={loadingShoppingCenters}
        showInsegna={false}
        showCategorie={false}
        enableSorting={true}
        filters={filters}
      />
    );
  },
); 